export const stages = [
  { key: 'enquiry', name: 'Enquiry', statusClass: 'status-primary', dateField: null },
  { key: 'qualified', name: 'Qualified', statusClass: 'status-info', dateField: 'qualified_at' },
  { key: 'proposal', name: 'Proposal', statusClass: 'status-warning', dateField: 'proposal_at' },
  { key: 'won', name: 'Won', statusClass: 'status-success', dateField: 'won_at' },
  { key: 'lost', name: 'Lost', statusClass: 'status-danger', dateField: 'lost_at' }
]

export const stageByKey = (key) => stages.find((stage) => stage.key === key)

export const stageName = (key) => (stageByKey(key) || {}).name || key

export const stageClass = (key) => (stageByKey(key) || {}).statusClass || ''

export const channels = {
  google_ads: 'Google Ads',
  organic_search: 'Organic search',
  social: 'Social',
  ai_assistant: 'AI assistant',
  referral: 'Referral',
  direct: 'Direct'
}

export const channelName = (key) => channels[key] || key
